import { Chip } from "@mui/material";
import { MULTIPLE_VALUES_INDICATOR } from "helpers/skuQualificationHelpers";

type MultiValueCellProps = {
  value: any;
};

export const MultiValueCell = ({ value }: MultiValueCellProps) => {
  if (value === MULTIPLE_VALUES_INDICATOR) {
    return <Chip size="small" label="Multiple Values" />;
  }
  if (value instanceof Date) {
    return <>{value.toLocaleDateString()}</>;
  }
  return <>{value}</>;
};
